import { Component } from '@angular/core';

import { DemoScheduledEmailsService } from '@demo/module-instance/demo-scheduled-emails/demo-scheduled-emails.service';
import { ScheduledEmailsComponent } from '@module-instance/scheduled-emails/scheduled-emails.component';
import { ScheduledEmailService } from '@module-instance/scheduled-emails/scheduled-emails.service';

@Component({
  selector: 'app-demo-scheduled-emails',
  template: '<div class="p-a-xl"><app-scheduled-emails/></div>',
  providers: [{ provide: ScheduledEmailService, useClass: DemoScheduledEmailsService }],
  imports: [ScheduledEmailsComponent],
})
export class DemoScheduledEmailsComponent {}
